import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import * as moment from 'moment-timezone';
import {forkJoin} from 'rxjs';
import { LanguagesEnum } from '../../auth/model/languages.enum';
import { BaseHttpService } from '../services/base-http.service';
import { StorageService } from '../storage/storage.service';

@Injectable()
export class TranslateService extends BaseHttpService {

  data: any = {};
  lang: string;

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  use(lang: string): Promise<{}> {
    if (this.lang === lang) {
      return new Promise<{}>((resolve, reject) => resolve(this.data));
    }
    this.lang = lang || LanguagesEnum.PL;
    return new Promise<{}>((resolve, reject) => {
      const langPath = `/assets/i18n/${lang || LanguagesEnum.PL}.json`;
      const changelogLangPath = `/assets/i18n/changelog_${lang || LanguagesEnum.PL}.json`;
      moment.locale(lang);
      const subsciptions = [];
      subsciptions.push(this._http.get<{}>(langPath));
      subsciptions.push(this._http.get<{}>(changelogLangPath));

      forkJoin(subsciptions).subscribe(data => {
        this.data = Object.assign({}, data[0] || {}, data[1] || {});
        resolve(this.data);
      }, error => {
        this.data = {};
        resolve(this.data);
      });
    });
  }
}
